import { createSelector } from '@reduxjs/toolkit';

import { getQueryBuilderModel } from 'src/containers/ProjectDiagram/utils/getQueryBuilderModel';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const projectRuleModelSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(diagramSnapshotSelector(projectId), (diagram) =>
      diagram
        ? getQueryBuilderModel(diagram.model)
        : { classesByIri: {}, propertiesByIri: {} }
    )
);
